export default {
  title: 'Er du sikker på, at du vil logge ud?',
  buttons: {
    logout: 'Log ud',
    cancel: 'Annuller',
  },
};
